import httpClient from 'api/httpClient';
import { NudgeNotification } from 'models/Notification';

function getActiveNudgeNotification() {
  return httpClient.get<{ notification: NudgeNotification }>(
    'nudges/active-notification',
  );
}

function confirmInterest(id: string) {
  return httpClient.post(`nudges/${id}/confirm`);
}

function snoozeNudgeNotification(id: string) {
  return httpClient.post(`nudges/${id}/snooze`);
}

export default {
  getActiveNudgeNotification,
  confirmInterest,
  snoozeNudgeNotification,
};
